var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"customer-status-badge",attrs:{"small":"","color":_vm.color,"text-color":_vm.textColor,"outlined":_vm.outlined}},[_c('v-icon',{attrs:{"left":"","x-small":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.label)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }